import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingEnterpriseForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="enterprise"
      settingKey="enterprise_role_setting"
    />
  );
}

export default SpacesSettingEnterpriseForm;
